module.exports = ".col-login {\r\n    max-width: 35rem !important;\r\n}\r\n\r\nngx-recaptcha2 div { display: inline-block; }"